export default class AnimalIcon extends Phaser.Sprite {
  constructor(game, x, y, playerNr, animal) {
    super(game, x, y, 'ui_player_mode', 'circle_' + animal);
    this.anchor.set(0.5);

    this.icon = this.game.make.image(-10, 50, 'ui_player_mode', 'icon_' + animal);
    this.icon.anchor.set(0.5, 1);
    this.addChild(this.icon);

    this.text = this.game.make.text(0, 10, playerNr, {
      font: '70px Elinor',
      fill: '#FFFFFF',
    });
    this.text.anchor.set(0.5, 0);
    this.addChild(this.text);
  }

  setHudMode() {
    this.icon.scale.set(0.9);
    this.text.scale.set(0.8);
    this.icon.x = this.text.x = 33;
    this.icon.y = 28;
    this.text.y = 8;
  }

  animateToHudMode(time) {
    this.game.add.tween(this.icon).to({ x: 33, y: 28 }, time, null, true);
    this.game.add.tween(this.icon.scale).to({ x: 0.9, y: 0.9 }, time, null, true);
    this.game.add.tween(this.text).to({ x: 33, y: 8 }, time, null, true);
    this.game.add.tween(this.text.scale).to({ x: 0.8, y: 0.8 }, time, null, true);
  }
}
